module.exports = __webpack_public_path__ + "static/media/visa.b80360e2.png";